<template>
    <div class="dots d-flex flex-column py-5" style="height: 300px">
        <h1 class="mx-auto mb-3">Naše nejnovější práce</h1>
        <a href="#projekty" class="mt-auto" id="projekty">
        <div class="inner-circle mx-auto ">
            <div class="play"></div>
        </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "DotsComponent"
}
</script>

<style scoped>

</style>
